import { Field, Form } from "react-final-form";

import { LANGUAGE } from "@/constants";
import { useChannel } from "@/contexts/ChannelContext";
import { Channel } from "@/types/Channel";
import { capitalize, cx } from "@/utils";
import Button from "@components/Button";
import { FF_Checkbox, FF_InputField, FF_SelectField } from "@components/Field";
import Typography from "@components/Typography";

import styles from "./ChannelSettings.module.css";

type ChannelSettingsProps = {
  onTranscribeAll: () => void;
  transcribingAll: boolean;
  onReindexEpisodes?: () => void;
  reindexingEpisodes?: boolean;
};

const ChannelSettings = ({
  onTranscribeAll,
  transcribingAll,
  onReindexEpisodes,
  reindexingEpisodes,
}: ChannelSettingsProps) => {
  const { channel, updateChannel } = useChannel();

  return (
    <Form<Channel>
      onSubmit={updateChannel}
      initialValues={{
        automatic_transcription: channel?.automatic_transcription,
        weekly_reach_in_thousands: channel?.weekly_reach_in_thousands,
        language: channel?.language,
      }}
    >
      {({ handleSubmit, dirty }) => (
        <form onSubmit={handleSubmit}>
          <Typography variant="subtitle-2">
            Channel settings{" "}
            <span className={styles.titleSpan}>
              (changes only apply to future episodes)
            </span>
          </Typography>
          <hr className={styles.divider} />
          <div className={styles.transcribeRow}>
            <Field
              className={styles.transcribeField}
              name="automatic_transcription"
              label="Always transcribe new episodes"
              render={FF_Checkbox}
              type="checkbox"
            />
            <Button
              type="button"
              size="sm"
              variant="secondary"
              onClick={onTranscribeAll}
              disabled={transcribingAll}
            >
              Transcribe all
            </Button>
          </div>
          <div className={cx(styles.transcribeRow, styles.rightAligned)}>
            <Button
              type="button"
              size="sm"
              variant="secondary"
              onClick={onReindexEpisodes}
              disabled={reindexingEpisodes}
            >
              Reindex episodes
            </Button>
          </div>
          <Field
            className={styles.field}
            name="weekly_reach_in_thousands"
            label="Reach per week (in thousands)"
            placeholder="Reach"
            render={FF_InputField}
          />
          <Field
            className={styles.field}
            name="language"
            label="Language"
            render={FF_SelectField}
            placeholder="Language"
            nullable
          >
            {Object.entries(LANGUAGE).map(([key, value]) => (
              <option key={value} value={value}>
                {capitalize(key)}
              </option>
            ))}
          </Field>
          <Button type="submit" disabled={!dirty}>
            Save changes
          </Button>
        </form>
      )}
    </Form>
  );
};

export default ChannelSettings;
